export default __webpack_public_path__ + "static/media/bnbx_image.e381d8d4.png";